export enum ErrorType {
  ERROR_404 = 'ERROR_404',
  ERROR_500 = 'ERROR_500',
  SYSTEM_CHECK = 'SYSTEM_CHECK'
}